// Single source of truth for the brand primary color.
// Change PRIMARY_COLOR here to re-theme the whole app.
export const PRIMARY_COLOR = "#00416ccc";
// RGB triplet for libraries that need numeric channels (e.g. jsPDF fillColor).
export const PRIMARY_COLOR_RGB = [0, 65, 108];
